import React from "react";
import { Controller, useFormContext } from "react-hook-form";
import Slider from "react-slick";
import styles from "./SelectPackages.module.scss";
import Typography from "@/foundation/Typography/V2";

const SelectPackages = ({
  name,
  control,
  packages,
  packagePlaceholder,
  handleBlur,
}) => {
  const { setValue } = useFormContext();
  const settings = {
    dots: false,
    lazyLoad: false,
    infinite: false,
    speed: 500,
    slidesToShow: 2.8,
    slidesToScroll: 1,
    prevArrow: null, // Hide the left arrow
    nextArrow: null, // Hide the right arrow
  };
  return (
    <Controller
      name={name}
      control={control}
      shouldUnregister
      render={({
        field: { value, onBlur, onChange, ref },
        fieldState: { error },
      }) => (
        <div className={styles.packageDuration}>
          <div className={styles.label}>{packagePlaceholder}</div>
          <div className={styles.durationList}>
            <Slider {...settings}>
              {packages?.map(
                (
                  {
                    title,
                    duration,
                    price,
                    strikeoutPrice,
                    currencySymbol,
                    metaTagData,
                    slug,
                  },
                  index
                ) => (
                  <div
                    className={[
                      styles.duration,
                      slug === value ? "selected" : "",
                    ].join(" ")}
                    key={duration}
                    value={value}
                    onClick={() => {
                      onChange(slug);
                      setValue("duration", duration);
                    }}
                    onBlur={(e) => {
                      onBlur(e).then((e) => handleBlur(e));
                    }}
                  >
                    {metaTagData?.isNewPackage && (
                      <div className={styles.tag}>
                        <Typography
                          variant="paragraph4"
                          className={styles.tagText}
                        >
                          {metaTagData?.isNewPackage}
                        </Typography>
                      </div>
                    )}
                    <div className={styles.textContainer}>
                      <Typography variant="label1" className={styles.title}>
                        {metaTagData.displayHeading || title}
                      </Typography>
                      <Typography
                        variant="paragraph4"
                        className={styles.subTitle}
                      >
                        {metaTagData.displaySubHeading}
                      </Typography>
                    </div>
                    <div className={styles.priceContainer}>
                      <div
                        className={styles.price}
                        dangerouslySetInnerHTML={{
                          __html: `${currencySymbol} ${price}`,
                        }}
                      />
                      <div
                        className={styles.strikeoutPrice}
                        dangerouslySetInnerHTML={{
                          __html: `${currencySymbol} ${strikeoutPrice}`,
                        }}
                      />
                    </div>
                  </div>
                )
              )}
            </Slider>
          </div>
          <div className={styles.durationListWeb}>
            {packages?.map(
              (
                {
                  title,
                  duration,
                  price,
                  strikeoutPrice,
                  currencySymbol,
                  metaTagData,
                  slug,
                },
                index
              ) => (
                <div
                  className={[
                    styles.duration,
                    slug === value ? "selected" : "",
                  ].join(" ")}
                  key={duration}
                  value={value}
                  onClick={() => {
                    onChange(slug);
                    setValue("duration", duration);
                  }}
                  onBlur={(e) => {
                    onBlur(e).then((e) => handleBlur(e));
                  }}
                >
                  {metaTagData?.isNewPackage && (
                    <div className={styles.tag}>
                      <Typography
                        variant="paragraph4"
                        className={styles.tagText}
                      >
                        {metaTagData?.isNewPackage}
                      </Typography>
                    </div>
                  )}
                  <div className={styles.textContainer}>
                    <Typography variant="label1" className={styles.title}>
                      {metaTagData.displayHeading || title}
                    </Typography>
                    <Typography
                      variant="paragraph4"
                      className={styles.subTitle}
                    >
                      {metaTagData.displaySubHeading}
                    </Typography>
                  </div>
                  <div className={styles.priceContainer}>
                    <div
                      className={styles.price}
                      dangerouslySetInnerHTML={{
                        __html: `${currencySymbol} ${price}`,
                      }}
                    />
                    <div
                      className={styles.strikeoutPrice}
                      dangerouslySetInnerHTML={{
                        __html: `${currencySymbol} ${strikeoutPrice}`,
                      }}
                    />
                  </div>
                </div>
              )
            )}
          </div>
        </div>
      )}
    />
  );
};

export default SelectPackages;
